// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__17X-d","footer":"ModalCreateQualiphyProcedure_footer__2WQdy","additionData":"ModalCreateQualiphyProcedure_additionData__2flmk"};